import { Navigate, useLocation } from 'react-router-dom';
export default function LegacyHealthcareRedirect() {
  const { pathname, search, hash } = useLocation();
  const path = pathname.replace(/\/health(?=\/|$)/g, '/healthcare').replace('/health-service-planning', '/healthcare-service-planning');
  return <Navigate replace to={path + search + hash} />;
}
